export function getTotalWeight(weights) {
  if (!weights) return 0;

  return (
    (weights.steer || 0) +
    (weights.drive || 0) +
    (weights.trailerA || 0) +
    (weights.trailerB || 0)
  );
}

export function getTruckWeight(weights) {
  if (!weights) return 0;

  return (
    (weights.steer || 0) +
    (weights.drive || 0)
  );
}

export function getTrailerWeight(weights) {
  if (!weights) return 0;

  return (
    (weights.trailerA || 0) +
    (weights.trailerB || 0)
  );
}

// todo ujj send to legacy if not used
export function normaliseFleetList(fleetList = []) {
  const map = {};

  for (const fleet of fleetList) {
    map[fleet.vehicleId] = {
      ...fleet,
      totalWeight: getTotalWeight(fleet.weights),
      truckWeight: getTruckWeight(fleet.weights),
      trailerWeight: getTrailerWeight(fleet.weights),
      ts: fleet.timestamp ? new Date(fleet.timestamp).getTime() : 0,
    };
  }

  return map;
}


export function normaliseDetailsList(detailsList = []) {
  const map = {};

  for (const vehicle of detailsList) {
    map[vehicle._id] = {
      ...vehicle,
      totalWeightsMax: getTotalWeight(vehicle.weightsMax),
    };
  }

  return map;
}

// fleetUtils.js
export function computeHasAlert(fleet, details) {
  return (
    (details?.nextServiceOn &&
      new Date(details.nextServiceOn).getTime() < Date.now()) ||

    (fleet.totalWeight != null &&
      details?.totalWeightsMax != null &&
      fleet.totalWeight > details.totalWeightsMax)
  );
}

/**
 * IMPORTANT:
 * keep this LIGHT for performance
 */
export function isSameFleetRecordsss(prev, next) {
  return (
    prev.ts === next.ts &&
    prev.status === next.status &&
    prev.speedKmh === next.speedKmh &&
    prev.lat === next.lat &&
    prev.lng === next.lng &&
    prev.totalWeight === next.totalWeight &&
    prev.isOverweight === next.isOverweight &&
    prev.vehicleCode === next.vehicleCode &&
    prev.imageUrl === next.imageUrl &&
    prev.employee?._id === next.employee?._id &&
    prev.employee?.name === next.employee?.name &&
    prev.employee?.imageUrl === next.employee?.imageUrl &&
    prev.employee?.employeeCode === next.employee?.employeeCode
  );
}

//todo ujj light version
export function isSameFleetRecordssss(prev, next) {
  return (
    prev.ts === next.ts &&
    prev.speedKmh === next.speedKmh &&
    prev.status === next.status &&
    prev.totalWeight === next.totalWeight
  );
}
//too heavy
export function isSameFleetRecord(prev, next) {
  return (
    prev.status === next.status &&
    prev.speedKmh === next.speedKmh &&
    prev.lat === next.lat &&
    prev.lng === next.lng &&
    prev.address === next.address &&

    prev.hasAlert === next.hasAlert &&

    // weights (FULL check, not just total)
    prev.weights?.steer === next.weights?.steer &&
    prev.weights?.drive === next.weights?.drive &&
    prev.weights?.trailerA === next.weights?.trailerA &&
    prev.weights?.trailerB === next.weights?.trailerB &&

    prev.isStale === next.isStale &&

    //subscription
    prev.subscriptionStatus === next.subscriptionStatus &&

    // flags
    prev.flags?.harshAccel === next.flags?.harshAccel &&
    prev.flags?.harshBrake === next.flags?.harshBrake &&
    prev.flags?.binActive === next.flags?.binActive &&
    prev.flags?.ptoActive === next.flags?.ptoActive &&
    prev.flags?.tailGateActive === next.flags?.tailGateActive &&
    prev.flags?.tarpActive === next.flags?.tarpActive &&

    // computed
    prev.totalWeight === next.totalWeight &&
    prev.isOverweight === next.isOverweight &&

    // identity / linkage for when details update
    prev.vehicleCode === next.vehicleCode &&
    // vehicle/image details used in inspector
    prev.imageUrl === next.imageUrl &&

    prev.employeeId === next.employeeId &&

    // employee identity
    prev.employee?._id === next.employee?._id &&
    // employee fields used in UI
    prev.employee?.name === next.employee?.name &&
    prev.employee?.imageUrl === next.employee?.imageUrl &&
    prev.employee?.employeeCode === next.employee?.employeeCode

    // prev.fuel?.value === next.fuel?.value &&
    // prev.fuel?.unit === next.fuel?.unit &&

    // prev.voltage?.value === next.voltage?.value &&
    // prev.voltage?.unit === next.voltage?.unit &&

    // prev.sourceMeta?.sats === next.sourceMeta?.sats
  );
}

//for computing percent of load:
export function computeAxleLoadPct(weights = {}, weightsMax = {}) {
  return {
    steer:
      weightsMax.steer > 0
        ? Math.min((weights.steer || 0) / weightsMax.steer * 100, 100)
        : 0,
    drive:
      weightsMax.drive > 0
        ? Math.min((weights.drive || 0) / weightsMax.drive * 100, 100)
        : 0,
    trailerA:
      weightsMax.trailerA > 0
        ? Math.min((weights.trailerA || 0) / weightsMax.trailerA * 100, 100)
        : 0,
    trailerB:
      weightsMax.trailerB > 0
        ? Math.min((weights.trailerB || 0) / weightsMax.trailerB * 100, 100)
        : 0,
  };
}

export function computeBodyLoadPct(weights = {}, weightsMax = {}) {
  const truckWeight = (weights.steer || 0) + (weights.drive || 0);
  const truckMax = (weightsMax.steer || 0) + (weightsMax.drive || 0);

  const trailerWeight = (weights.trailerA || 0) + (weights.trailerB || 0);
  const trailerMax = (weightsMax.trailerA || 0) + (weightsMax.trailerB || 0);

  return {
    truck:
      truckMax > 0 ? Math.min((truckWeight / truckMax) * 100, 100) : 0,
    trailer:
      trailerMax > 0 ? Math.min((trailerWeight / trailerMax) * 100, 100) : 0,
  };
}

//calculate bearing based on previous and current geocoordinates
const toRadians = (degrees) => (degrees * Math.PI) / 180;
const toDegrees = (radians) => (radians * 180) / Math.PI;

const calculateBearing = (prevLat, prevLng, nextLat, nextLng) => {
  const lat1 = toRadians(prevLat);
  const lat2 = toRadians(nextLat);
  const deltaLng = toRadians(nextLng - prevLng);

  const y = Math.sin(deltaLng) * Math.cos(lat2);

  const x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(deltaLng);

  const bearing = toDegrees(Math.atan2(y, x));
  return (bearing + 360) % 360;
}

const calculateDistanceMeters = (lat1, lng1, lat2, lng2) => {
  const earthRadius = 6371000;

  const deltaLat = toRadians(lat2 - lat1);
  const deltaLng = toRadians(lng2 - lng1);

  const a =
    Math.sin(deltaLat / 2) ** 2 +
    Math.cos(toRadians(lat1)) *
    Math.cos(toRadians(lat2)) *
    Math.sin(deltaLng / 2) ** 2;

  return earthRadius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

// use backend bearing when available. Otherwise calculate it from the previous and current locations.
export const processBearing = ({
  previousRecord,
  currentRecord,
  lat,
  lng,
  minimumDistance = 3,
}) => {
  const normalizeBearing = (value) =>
    ((value % 360) + 360) % 360;

  const suppliedBearing = Number(
    currentRecord?.bearing ?? currentRecord?.heading,
  );

  // Prefer bearing supplied by the tracking device.
  if (Number.isFinite(suppliedBearing)) {
    return normalizeBearing(suppliedBearing);
  }

  const currentLat = Number(lat);
  const currentLng = Number(lng);
  const previousLat = Number(previousRecord?.lat);
  const previousLng = Number(previousRecord?.lng);

  // Check null separately because Number(null) equals 0.
  const hasCurrentPosition =
    lat != null &&
    lng != null &&
    Number.isFinite(currentLat) &&
    Number.isFinite(currentLng);

  const hasPreviousPosition =
    previousRecord?.lat != null &&
    previousRecord?.lng != null &&
    Number.isFinite(previousLat) &&
    Number.isFinite(previousLng);

  const previousBearing = Number(
    previousRecord?.trackingBearing,
  );

  const fallbackBearing = Number.isFinite(previousBearing)
    ? normalizeBearing(previousBearing)
    : null;

  if (!hasCurrentPosition || !hasPreviousPosition) {
    return fallbackBearing;
  }

  const distanceMoved = calculateDistanceMeters(
    previousLat,
    previousLng,
    currentLat,
    currentLng,
  );

  // Preserve the previous orientation for stationary GPS jitter.
  if (distanceMoved < minimumDistance) {
    return fallbackBearing;
  }

  return calculateBearing(
    previousLat,
    previousLng,
    currentLat,
    currentLng,
  );
};